import { render } from "./app-layout.vue?vue&type=template&id=df8b361e"
import script from "./app-layout.vue?vue&type=script&lang=js"
export * from "./app-layout.vue?vue&type=script&lang=js"

import "./app-layout.vue?vue&type=style&index=0&id=df8b361e&lang=scss"
script.render = render

export default script